import { Grid, SelectChangeEvent, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import {
  Applicant,
  ApplicantAddressType,
  Broker,
  BrokerList,
  ContactPerson,
  Fatcadetails,
  KraDocumentType,
} from '../../redux-store/types/api-types';
import {
  ckycFieldValidationDate,
  AOI_BOI_MASTER,
  grossAnnualMasters,
  investorTypeMasters,
  KBOLT_XALT_MASTER,
  KRA_STATUS_MASTER,
  PEPsMasters,
  sourceOfFundFieldValidationDate,
  SourceOfFundMaster,
  USER_ROLES,
  accredidateValidationDate,
  npoValidationDate,
  yesNoMaster,
  REtypeMaster,
  reTypeValidationDate,
  nbfcValidationDate,
  servicesMaster,
  serviceValidationDate,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkSourceOfFundOthers,
  checkValidationBasedOnDate,
  clearclIdField,
  cleardpIdField,
  currencyConversion,
  dlclIdFieldMandatory,
  removeSingleQuote,
  saveForLater,
  ifPushToXalt,
  isDprFieldApplicable,
  OthersOptionForRE,
  reTypeNAOption,
  getServicesUpdate,
  getIsServiceRequired,
  isLVFschemeCode,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getBrokers, updateApplication } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { DematDetails } from '../investors/additionalKYCDetails';
import { PPMNo } from '../investors/contributorDetails';
import MFCheckbox from '../../lib/formik/Checkbox';
import UseRadioGroup from '../../lib/formik/Radio';
import { isNotNpoDeclaration, isNpoDeclaration } from '../../utils/declaration';
import MultiSelectCheckbox from '../../lib/formik/MultiCheckbox';

export type _Applicant = Applicant & {
  isServicesRequired: string[];
  [key: string]:
    | string
    | null
    | number
    | undefined
    | boolean
    | Partial<ApplicantAddressType>[]
    | ContactPerson
    | KraDocumentType
    | Fatcadetails
    | (boolean | null)[]
    | string[];
};

const contributorObject: Partial<_Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  kraStatus: '',
  grossAnnualIncome: '',
  netWorth: '',
  politicallyExposedPersonStatus: '',
  sourceOfFunds: '',
  sourceOfFundsOthers: '',
  dlclId: dlclIdFieldMandatory() ? '' : 'none',
  dpId: '',
  clId: '',
  nameOfBroker: '',
  kraMobileNumber: '',
  kraEmailId: '',
  boiOrAop: '',
  darpanRegistrationNo: '',
  isNotNpo: false,
  isNpo: false,
  isTrustEntity: '',
  reType: '',
  reTypeOthers: '',
  RBIRegNo: '',
  isNbfc: '',
  isServicesRequired: [],
  rbiRegulatedEntity: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<_Applicant>[];
  ppmNo: string | number | null;
  isAccreditedInvestor: boolean;
  isEmployeeOrSponsor: boolean;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  ppmNo: null,
  isAccreditedInvestor: false,
  isEmployeeOrSponsor: false,
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [brokerList, setBrokerList] = useState<BrokerList>();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    try {
      const { applicants = [], ppmNo = null } = application || {};
      setContributorValues({
        ...contributorValues,
        ppmNo,
        isEmployeeOrSponsor: application?.isEmployeeOrSponsor || false,
        isAccreditedInvestor: checkValidationBasedOnDate(
          application?.createdAt || '',
          accredidateValidationDate
        )
          ? isLVFschemeCode(application?.scheme.schemeCode || '') &&
            !application?.isEmployeeOrSponsor
            ? true
            : application?.isAccreditedInvestor || false
          : false,
        applicants: applicants.length
          ? applicants.map((applicant) => {
              const isServicesRequired = getIsServiceRequired(applicant);
              return {
                ...applicant,
                dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
                nameOfBroker: applicant.nameOfBroker || '',
                sourceOfFunds: applicant.sourceOfFunds || '',
                sourceOfFundsOthers: applicant.sourceOfFundsOthers || '',
                boiOrAop: applicant.boiOrAop || '',
                darpanRegistrationNo: applicant.darpanRegistrationNo || '',
                isNpo: applicant.isNpo ? applicant.isNpo : false,
                isNotNpo: applicant.isNotNpo ? applicant.isNotNpo : false,
                isTrustEntity: applicant.isTrustEntity || '',
                reType:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  shouldShowRBICategory(applicant.rbiRegulatedEntity || '')
                    ? applicant?.reType || ''
                    : '',
                // reTypeOthers: OthersOptionForRE(applicant.reType || '')
                //   ? applicant.reTypeOthers || ''
                //   : '',
                RBIRegNo:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  shouldShowRBICategory(applicant.rbiRegulatedEntity || '') &&
                  applicant.reType
                    ? applicant.RBIRegNo || ''
                    : '',
                isNbfc:
                  ['corporate', 'bank', 'institutional_investor'].includes(
                    applicant.investorType || ''
                  ) && checkValidationBasedOnDate(application?.createdAt || '', nbfcValidationDate)
                    ? applicant.isNbfc || ''
                    : '',
                isServicesRequired: checkValidationBasedOnDate(
                  application?.createdAt || '',
                  serviceValidationDate
                )
                  ? isServicesRequired
                  : [],
                rbiRegulatedEntity: checkValidationBasedOnDate(
                  application?.createdAt || '',
                  reTypeValidationDate
                )
                  ? applicant.rbiRegulatedEntity
                  : '',
              };
            })
          : ([contributorObject] as _Applicant[]),
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const {
      saveType,
      applicants = [],
      ppmNo = null,
      isAccreditedInvestor,
      isEmployeeOrSponsor,
    } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: applicants
          .map((applicant, index) => {
            const { isServicesRequired, ...rest } = applicant;
            return {
              ...application?.applicants[0],
              ...rest,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
              sourceOfFundsOthers: checkSourceOfFundOthers(
                (applicant.sourceOfFunds as string) || ''
              )
                ? applicant.sourceOfFundsOthers
                : '',
              accreditationCertificateNumber:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(application?.createdAt || '', accredidateValidationDate)
                  ? applicant.accreditationCertificateNumber || ''
                  : '',
              accreditationValidFrom:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(application?.createdAt || '', accredidateValidationDate)
                  ? applicant.accreditationValidFrom || null
                  : null,
              accreditationValidTo:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(application?.createdAt || '', accredidateValidationDate)
                  ? applicant.accreditationValidTo || null
                  : null,
              isTrustEntity:
                investorTypeMasters[applicant.investorType || ''] === investorTypeMasters.trust &&
                checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
                  ? applicant.isTrustEntity
                  : '',
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicants[index]?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicants[index].boiOrAop
                  : '',
              reType:
                checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                  ? applicants[index].reType || ''
                  : '',
              // reTypeOthers:
              //   checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
              //   OthersOptionForRE(applicants[index].reType || '')
              //     ? applicants[index].reTypeOthers || ''
              //     : '',
              RBIRegNo:
                checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                applicants[index].reType &&
                shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                  ? applicants[index].RBIRegNo || ''
                  : '',
              isNbfc:
                ['corporate', 'bank', 'institutional_investor'].includes(
                  applicant?.investorType || ''
                ) && checkValidationBasedOnDate(application?.createdAt || '', nbfcValidationDate)
                  ? applicant.isNbfc
                  : '',
              ...getServicesUpdate(
                checkValidationBasedOnDate(application?.createdAt || '', serviceValidationDate)
                  ? isServicesRequired || []
                  : []
              ),
              rbiRegulatedEntity: checkValidationBasedOnDate(
                application?.createdAt || '',
                reTypeValidationDate
              )
                ? applicant.rbiRegulatedEntity
                : '',
            };
          })
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        ppmNo,
        isAccreditedInvestor: isAccreditedInvestor,
        isEmployeeOrSponsor: isEmployeeOrSponsor,
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: applicants.map((applicant, index) => {
              const { isServicesRequired, ...rest } = applicant;
              return {
                ...application?.applicants[0],
                ...rest,
                name: removeSingleQuote(applicant.name),
                cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
                clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
                dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
                nameOfBroker: cleardpIdField(applicant.dlclId || '') ? '' : applicant.nameOfBroker,
                sourceOfFundsOthers: checkSourceOfFundOthers(
                  (applicant.sourceOfFunds as string) || ''
                )
                  ? applicant.sourceOfFundsOthers
                  : '',
                isTrustEntity:
                  investorTypeMasters[applicant.investorType || ''] === investorTypeMasters.trust &&
                  checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
                    ? applicant.isTrustEntity
                    : '',
                darpanRegistrationNo:
                  isDprFieldApplicable(
                    applicant.investorType || '',
                    applicant.isTrustEntity || ''
                  ) &&
                  applicant.isNpo &&
                  checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
                    ? applicant.darpanRegistrationNo
                    : '',
                isNpo:
                  isDprFieldApplicable(
                    applicant.investorType || '',
                    applicant.isTrustEntity || ''
                  ) && checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
                    ? applicant.isNpo
                    : false,
                isNotNpo:
                  isDprFieldApplicable(
                    applicant.investorType || '',
                    applicant.isTrustEntity || ''
                  ) && checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
                    ? applicant.isNotNpo
                    : false,
                boiOrAop:
                  ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop
                    ? applicants[index].boiOrAop
                    : '',
                reType:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                    ? applicants[index].reType || ''
                    : '',
                // reTypeOthers:
                //   checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                //   OthersOptionForRE(applicants[index].reType || '')
                //     ? applicants[index].reTypeOthers || ''
                //     : '',
                RBIRegNo:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  applicants[index].reType &&
                  shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                    ? applicants[index].RBIRegNo || ''
                    : '',
                isNbfc:
                  ['corporate', 'bank', 'institutional_investor'].includes(
                    applicant?.investorType || ''
                  ) && checkValidationBasedOnDate(application?.createdAt || '', nbfcValidationDate)
                    ? applicant.isNbfc
                    : '',
                ...getServicesUpdate(
                  checkValidationBasedOnDate(application?.createdAt || '', serviceValidationDate)
                    ? isServicesRequired || []
                    : []
                ),
                accreditationCertificateNumber:
                  isAccreditedInvestor &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    accredidateValidationDate
                  )
                    ? applicant.accreditationCertificateNumber || ''
                    : '',
                accreditationValidFrom:
                  isAccreditedInvestor &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    accredidateValidationDate
                  )
                    ? applicant.accreditationValidFrom || null
                    : null,
                accreditationValidTo:
                  isAccreditedInvestor &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    accredidateValidationDate
                  )
                    ? applicant.accreditationValidTo || null
                    : null,
                rbiRegulatedEntity: checkValidationBasedOnDate(
                  application?.createdAt || '',
                  reTypeValidationDate
                )
                  ? applicant.rbiRegulatedEntity
                  : '',
              };
            }),
            ppmNo,
            modeOfHolding: 'single',
            isAccreditedInvestor: isAccreditedInvestor,
            isEmployeeOrSponsor: isEmployeeOrSponsor,
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      await handleApplicant(values);
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              brokerList?.broker_list as Broker[],
              application?.createdAt || '',
              ifPushToXalt(application?.pushDataTo || '')
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <PPMNo />
            <Grid item xs={12}>
              <MFCheckbox
                name="isEmployeeOrSponsor"
                label="I am an Employee or Sponsor"
                onChange={({ target: { checked } }) => {
                  if (isLVFschemeCode(application?.scheme.schemeCode || '')) {
                    setFieldValue('isAccreditedInvestor', true);
                  }
                  setFieldValue('isEmployeeOrSponsor', checked);
                }}
                disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false}
              />
            </Grid>
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              accredidateValidationDate
            ) && (
              <Grid item xs={12}>
                <MFCheckbox
                  name="isAccreditedInvestor"
                  label="I am an accredited investor"
                  checked={
                    isLVFschemeCode(application?.scheme.schemeCode || '') &&
                    !values?.isEmployeeOrSponsor
                      ? true
                      : values.isAccreditedInvestor || false
                  }
                  onChange={({ target: { checked } }) => {
                    if (
                      isLVFschemeCode(application?.scheme.schemeCode || '') &&
                      !values?.isEmployeeOrSponsor
                    ) {
                      setFieldValue('isAccreditedInvestor', true);
                      return;
                    }
                    setFieldValue('isAccreditedInvestor', checked);
                    if (!checked) {
                      values.applicants.forEach((_, index) => {
                        setFieldValue(`applicants.${index}.accreditationCertificateNumber`, '');
                        setFieldValue(`applicants.${index}.accreditationValidFrom`, null);
                        setFieldValue(`applicants.${index}.accreditationValidTo`, null);
                      });
                    }
                  }}
                  disabled={
                    isLVFschemeCode(application?.scheme.schemeCode || '') &&
                    !values?.isEmployeeOrSponsor
                  }
                />
              </Grid>
            )}
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                {console.log(values, 'checkvalues')}
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.ckycNo`}
                    label={`Enter CKYC No./CKYC Acknowledge No./KIN No. ${
                      checkValidationBasedOnDate(
                        application?.createdAt || '',
                        ckycFieldValidationDate
                      )
                        ? ' *'
                        : ''
                    }`}
                    placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMasters).map((investor) => ({
                      key: investorTypeMasters[investor],
                      value: investor,
                    }))}
                  />
                </Grid>
                {/* {ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[values?.applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.boiOrAop`}
                        label="AOP or BOI *"
                        items={Object.keys(AOI_BOI_MASTER).map((investor) => ({
                          key: AOI_BOI_MASTER[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )} */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                {![USER_ROLES.AUTHORISEDSIGNATORY, USER_ROLES.INVESTOR].includes(role) &&
                  values.applicants[index].kraStatus && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.kraStatus`}
                        label="KRA Status *"
                        items={Object.keys(KRA_STATUS_MASTER).map((item) => ({
                          key: KRA_STATUS_MASTER[item],
                          value: item,
                        }))}
                        disabled={true}
                      />
                    </Grid>
                  )}
                {applicant.kraMobileNumber && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraMobileNumber`}
                      label={`KRA Mobile Number`}
                      placeholder="Enter KRA Mobile Number"
                      disabled={true}
                    />
                  </Grid>
                )}
                {['corporate', 'bank', 'institutional_investor'].includes(
                  values.applicants[index].investorType || ''
                ) &&
                  checkValidationBasedOnDate(application?.createdAt || '', nbfcValidationDate) && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.isNbfc`}
                        label="Is NBFCs (including Housing Finance Companies) *"
                        items={Object.keys(yesNoMaster).map((value) => ({
                          key: yesNoMaster[value],
                          value,
                        }))}
                      />
                    </Grid>
                  )}
                {applicant.kraEmailId && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraEmailId`}
                      label={`KRA Email Id`}
                      placeholder="Enter KRA Email Id"
                      disabled={true}
                    />
                  </Grid>
                )}
                {investorTypeMasters[values.applicants[index].investorType || ''] ===
                  investorTypeMasters.trust &&
                  checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate) && (
                    <Grid item xs={12} sm={6}>
                      <UseRadioGroup
                        formLabel="Is NPO"
                        name={`applicants.${index}.isTrustEntity`}
                        items={Object.keys(yesNoMaster).map((item) => ({
                          label: yesNoMaster[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                  )}
                {isDprFieldApplicable(
                  values.applicants[index].investorType || '',
                  applicant.isTrustEntity || ''
                ) &&
                  checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate) && (
                    <>
                      <Grid item xs={12}>
                        <MFCheckbox
                          name={`applicants.${index}.isNpo`}
                          label={isNpoDeclaration}
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                            alignItems: 'flex-start',
                            '.MuiTypography-root': {
                              fontSize: 15,
                              fontWeight: 500,
                            },
                          }}
                          checked={values.applicants[index].isNpo}
                          onChange={() => {
                            const current = values.applicants[index].isNpo;
                            setFieldValue(`applicants.${index}.isNpo`, !current);
                            setFieldValue(`applicants.${index}.isNotNpo`, false);
                          }}
                          // disabled={values.applicants[index].isNotNpo}
                        />
                      </Grid>
                      {
                        <Grid item xs={12} sm={6}>
                          <MFTextField
                            name={`applicants.${index}.darpanRegistrationNo`}
                            label={
                              values.applicants[index].isNpo
                                ? `Darpan Portal Registration Number *`
                                : 'Darpan Portal Registration Number'
                            }
                            placeholder={'Enter Darpan portal Registration Number'}
                          />
                        </Grid>
                      }
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, textAlign: 'center', my: 1 }}>
                          OR
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <MFCheckbox
                          name={`applicants.${index}.isNotNpo`}
                          label={isNotNpoDeclaration}
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                            alignItems: 'flex-start',
                            '.MuiTypography-root': {
                              fontSize: 15,
                              fontWeight: 500,
                            },
                          }}
                          //checked={values.applicants[index].isNotNpo}
                          checked={Boolean(values.applicants[index].isNotNpo)}
                          onChange={() => {
                            const current = values.applicants[index].isNotNpo;
                            setFieldValue(`applicants.${index}.isNotNpo`, !current);
                            setFieldValue(`applicants.${index}.isNpo`, false);
                          }}
                          // disabled={values.applicants[index].isNpo}
                        />
                      </Grid>
                    </>
                  )}
                {checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) && (
                  <>
                    {' '}
                    <Grid item xs={12} sm={6}>
                      <UseRadioGroup
                        formLabel="Are you a RBI Regulated Entity? *"
                        name={`applicants.${index}.rbiRegulatedEntity`}
                        items={Object.keys(yesNoMaster).map((item) => ({
                          label: yesNoMaster[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '') && (
                      <>
                        {' '}
                        <Grid item xs={12} sm={6}>
                          <MFSelectField
                            name={`applicants.${index}.reType`}
                            label="RE Types: *"
                            items={Object.keys(REtypeMaster).map((types) => ({
                              key: REtypeMaster[types],
                              value: types,
                            }))}
                          />
                        </Grid>
                        {values.applicants[index].reType && (
                          <Grid item xs={12} sm={6}>
                            <MFTextField
                              name={`applicants.${index}.RBIRegNo`}
                              label="RBI Registration Number"
                              placeholder={`Enter RBI Registration Number`}
                            />
                          </Grid>
                        )}
                        {/* {OthersOptionForRE(values.applicants[index].reType || '') && (
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.reTypeOthers`}
                          label="Please Specify Other Type *"
                          placeholder={`Enter Other RE Type`}
                        />
                      </Grid>
                    )} */}
                      </>
                    )}
                  </>
                )}
                {console.log(values.isAccreditedInvestor, 'val')}
                {values.isAccreditedInvestor &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    accredidateValidationDate
                  ) && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.accreditationCertificateNumber`}
                          label={`Accreditation Certificate Number *`}
                          placeholder="Enter Certificate Number"
                          // inputProps={{ maxLength: 12 }}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={`Accreditation Certificate Start Date *`}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidFrom`}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={`Accreditation Certificate End Date *`}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidTo`}
                          maxDate={null}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                    </>
                  )}
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income *"
                    items={grossAnnualMasters.map((grossIncome) => ({
                      key: grossIncome,
                      value: grossIncome,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth *"
                    placeholder="Enter Net Worth"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                    disabled={true}
                  />
                </Grid>
                {checkValidationBasedOnDate(
                  application?.createdAt as string,
                  sourceOfFundFieldValidationDate
                ) && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.sourceOfFunds`}
                        label="Source of Funds *"
                        items={Object.keys(SourceOfFundMaster).map((source) => ({
                          key: SourceOfFundMaster[source as string],
                          value: source,
                        }))}
                        onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                          setValues({
                            ...values,
                            applicants: values.applicants.map((detail: any, idx: number) => {
                              if (index === idx) {
                                return {
                                  ...detail,
                                  sourceOfFunds: value,
                                };
                              }
                              return detail;
                            }),
                          });
                        }}
                      />
                    </Grid>
                    {checkSourceOfFundOthers(
                      (values.applicants[index].sourceOfFunds as string) || ''
                    ) && (
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.sourceOfFundsOthers`}
                          label="Please Specify Source of Funds *"
                          placeholder={`Enter Source of Funds`}
                        />
                      </Grid>
                    )}
                  </>
                )}
                <DematDetails
                  values={values}
                  index={index}
                  brokers={brokerList?.broker_list as Broker[]}
                  disabled={false}
                />
                {checkValidationBasedOnDate(
                  application?.createdAt || '',
                  serviceValidationDate
                ) && (
                  <Grid item xs={12} sm={12}>
                    <MultiSelectCheckbox
                      options={Object.keys(servicesMaster).map((option) => ({
                        key: option,
                        value: servicesMaster[option],
                      }))}
                      name={`applicants.${index}.isServicesRequired`}
                      formLabel="Non-Individual investors involved/providing any of the mentioned services:"
                      selectedValues={values.applicants[index].isServicesRequired as string[]}
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))}
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
